import { Component, OnInit, EventEmitter } from '@angular/core';
import { fileInputParams, MessageService, SessionService, TableConfiguration, TableColumns, MenuBreadCrumb, LocalStorageService } from 'brainloper-ui';
import { EndpointDictionary } from 'src/app/utils/endpoints-dictionary';
import { Equipment } from 'src/app/models/maintenance/equipment';
import { ComponentEquipment } from 'src/app/models/maintenance/component';

@Component({
    selector: 'app-cve-equipo',
    templateUrl: './cve-equipo.component.html',
    styleUrls: ['./cve-equipo.component.scss'],
    standalone: false
})
export class CveEquipoComponent implements OnInit {

  //urlGetEquipos = `${environment.endpoint}${EndpointDictionary.Equipment.CRUD_EQUIPMENT_DATA}`;
  public urlGetComponentes = `${EndpointDictionary.ComponentEquipment.COMPONENT_EQUIPMENT_TABLE}`

  public data: IDataEquiment
  public companyId: number
  public dataComponentes: ComponentEquipment[]
  public titleLabel: string

  public fileInputEquipo: fileInputParams
  //tabla componentes

  public paramsCompoentes = [{ id: 'equipmentId', value: '' }]

  public titleComponentes = screen.width > 450 ? 'Componentes' : ''
  public recargarTablaComponentes = new EventEmitter<any>()
  public configurationComponentes: TableConfiguration = {
    edit: false,
    add: false,
    delete: false,
    selectable: false,
    primaryKey: 'id'
  }
  public columnasComponentes: TableColumns<ComponentEquipment>[] = [
    {
      ID: 'name',
      label: 'Nombre',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    },
    {
      ID: 'specifications',
      label: 'Especificaciones',
      type: 'text',
      style: {
        textAlign: 'center'
      },
    }


  ]
  public menuBreadCrumb: Array<MenuBreadCrumb> = [
    {
      name: "Inicio",
      router: '/inicio',
    },
    {
      name: "Equipos",
      router: '/mantenimiento/equipos',
    },
    {
      name: "Ficha tecnica",
      current: true
    }
  ]

  constructor(
    private message: MessageService,
    private session: SessionService,
    private storage: LocalStorageService
  ) {

    this.data = this.session.getData('cve')
    this.companyId = this.storage.get<number>('companyId')
    this.fileInputEquipo = {
      typeFile: "imagen",
      input: "vista",
      imageSrc: this.data.imgEquipo,
      edit: false,
      style: {
        width: '100%',
        height: screen.width > 400 ? '100%' : '60%',
        border: 'hidden'
      }
    }

  }

  ngOnInit(): void {

    this.dataComponentes = this.data.dataEquipo.components
    this.titleLabel = `${this.dataComponentes.length}  componentes`

    this.paramsCompoentes[0].value = this.data.dataEquipo.id.toString()
    this.recargarTablaComponentes.emit()

    for (let element of this.dataComponentes) {
      element.photo = `${EndpointDictionary.Base._BASE_URL_V2}${element.photo}/${this.companyId}`
    }
    this.message.closeLoading()

  }


}

interface IDataEquiment {
  action: string,
  dataEquipo: Equipment,
  imgEquipo: string
}
